import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'pendenza'
})

export class PendenzaPipe implements PipeTransform {
    /**
     * setta la pendenza in base al parametro passato
     * @param  {number} value
     */
    transform(value: number): string {
        let distanza: string = '<i class="fas fa-chart-line" title="Pendenza"></i> ' +  (value == null ? '0' : value.toString()) + ' m';
        return distanza;
    }
}